(ns ui.view.card.property-list.sub
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.field :as field]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.state.permissions :as f-permissions]
   [re-frame.core :as rf]
   [ui.state.session.sub :as session-sub]
   [ui.util :as uu]
   [ui.view.card.property-list.model :as model]
   [ui.view.card.sub :as common-sub]
   [common.schema.entities.pipeline :as pipeline]

   ;; TODO: Remove once possible
   [frontend.view.entity-viewers.entity-editor :as legacy-entity-editor]))

(defn resolve-entity-edit-diffs
  [original-entity edited-partial-entity]
  (->> edited-partial-entity
       (keys)
       (keep (fn [field]
               (let [new-value (get edited-partial-entity field)
                     new-value (if (vector? new-value)
                                 (set new-value)
                                 new-value)
                     old-value (get original-entity field)]
                 (when-not (= new-value old-value)
                   {:field     field
                    :new-value new-value
                    :old-value old-value}))))
       (vec)))

(defn resolve-entities-edit-diffs
  [original-entities-by-id entity-edits-by-id]
  (->> entity-edits-by-id
       (keep (fn [[entity-id partial-edited-entity]]
               (let [original-entity (get original-entities-by-id entity-id)
                     diffs (resolve-entity-edit-diffs original-entity partial-edited-entity)]
                 (when (seq diffs)
                   {:entity-id entity-id
                    :diffs     diffs}))))))

(rf/reg-sub
 ::edit-mode?
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/edit-mode-path)))

(rf/reg-sub
 ::entity-edits
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/entity-edits-path)))

(rf/reg-sub
 ::entity-edit-entities
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/entity-edit-entities-path)))

(rf/reg-sub
 ::unsaved-changes?
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])
    (rf/subscribe [::entity-edits ctx])])
 (fn [[entities entity-edits]]
   (let [differences (resolve-entities-edit-diffs entities entity-edits)]
     (boolean (seq differences)))))

(rf/reg-sub
 ::saving-changes?
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/saving-changes-path)))

(rf/reg-sub
 ::submit-errors
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/submit-errors-path)))

(rf/reg-sub
 ::show-all-fields-in-editor?
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/show-all-fields-in-editor-path)))

(rf/reg-sub
 ::all-editor-fields
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])
    (rf/subscribe [::session-sub/session-context])])
 (fn [[card-entities session-context] [_ {:keys [card entity-id] :as _ctx}]]
   (let [entity (get card-entities entity-id)
         card-fields-set (->> card
                              :card/config
                              :rows
                              (mapcat (fn [row]
                                        (->> row
                                             :cells
                                             (map :field))))
                              set)
         entity-template (legacy-entity-editor/resolve-template
                          (merge
                           session-context
                           {:entity                entity
                            :pipeline-id           (pipeline/pipeline entity)
                            :remove-fields         #{}
                            :override-editor-types nil}))
         fields (->> entity-template
                     (remove (fn [{:keys [attribute] :as field-schema}]
                               (or (card-fields-set attribute)
                                   ;; TODO: Should be remove secondary fields?
                                   (:field/secondary-field? field-schema))))
                     (sort-by (fn [{:keys [attribute] :as field-schema}]
                                (loc/field-name attribute field-schema)))
                     (mapv :attribute))]
     fields)))

;; TODO complete this
(defn resolve-field-options
  [{:keys [field-schema entities tenant]}]
  (let [field (:attribute field-schema)
        data-type (:field/data-type field-schema)
        option-filter-fn (:field/option-filter-fn field-schema)]
    (cond
      (or (= data-type :data.type/ref-single)
          (= data-type :data.type/ref-multi))
      (when (:named-value-attribute field-schema)
        (let [nv-attribute (:named-value-attribute field-schema)
              options
              (->> entities
                   (vals)
                   (filterv (fn [entity]
                              (= (:named-value/attribute entity) nv-attribute)))
                   (mapv (fn [entity]
                           {:value (:db/id entity)
                            :label (entity/display-string entity)})))]
          options))

      (or (= data-type :data.type/keyword)
          (= data-type :data.type/keyword-multi)
          (= data-type :data.type/currency-symbol))
      (let [initial-options (->> field-schema
                                 :options
                                 (mapv (fn [opt]
                                         {:value (or (:keyword opt)
                                                     (:key opt)
                                                     (:value opt))
                                          :label (:label opt)})))]
        ;; HACK: Option filter function needs to be re-thought now that we dont have the full entity lookup in frontend
        (if (and (fn? option-filter-fn)
                 (some #{field} [:company-counterparty-diligence/template
                                 :project-counterparty-diligence/template
                                 :person-counterparty-diligence/template]))
          (->> initial-options
               (filterv (fn [option]
                          (option-filter-fn {:tenant tenant
                                             :entity-candidate option}))))
          initial-options))


      :else nil)))

;; FIXME: Some interger fields are years so no thousand separators should be applied
;; This is not exhaustive set, maybe include this knowledge in the field schema?
(def year-fields-set
  #{:asset/year-project-funded
    :company/established-in
    :holding/year-of-entry
    :company/tesi-latest-capital-injection
    :fund/vintage-year
    :kpi-cycle/target-year
    :kpi-report-data/year
    :kpi-report/target-year
    :oppo/deal-year
    :oppo/decision
    :person/undergrad-year
    :person/graduate-year
    :person/doctoral-year
    :person/post-doctoral-year
    :real-estate/construction-year
    :value-creation/execution-year})

;; TODO: This is copied from frontend.components.inputs.select
;; Confirm from PO and Timo that this is indeed correct
;; Should be moved to common namespace?
(defn can-create-option-on-fly?
  [{:keys [field field-schema entity
           dealflow? fundraising? portfolio?]}]
  (let [entity-types (field/create-entity-types field-schema)
        create-on-fly? (:create-on-fly? field-schema)
        creatable-entity-types (when entity-types
                                 (->> entity-types
                                      (remove (fn [et]
                                                ;;TODO: should be updated to use a list of allowed entity-types.
                                                ;; likely solution: (-> common.schema.entity-types/entities :creatable-entity-types)
                                                ;; -note: it's missing at least named-value => won't use yet in case something else
                                                ;;        important is missing
                                                (some #{et}
                                                      [:entity.type/account
                                                       :entity.type/fund
                                                       :entity.type/team
                                                       :entity.type/webentry
                                                       :entity.type/kpi-category
                                                       :entity.type/pipeline])))))
        system-level-creatable? (some #{field}
                                      [:oppo/target-asset
                                       :investor/legal-entity
                                       :sale-agreement/customer
                                       :survey-profile/target
                                       :tenant/lp-portal-news-categories
                                       :tenant/lp-portal-news-types])
        single-creatable? (and creatable-entity-types
                               (= (count creatable-entity-types) 1))
        module-access? (case (first creatable-entity-types)
                         :entity.type/company true
                         :entity.type/real-estate true
                         :entity.type/fof-asset true
                         :entity.type/other-asset true
                         :entity.type/person true
                         :entity.type/investor true
                         :entity.type/oppo dealflow?
                         :entity.type/fundraising-opportunity fundraising?
                         :entity.type/holding portfolio?
                         :entity.type/any true
                         false)
        pipeline-id (pipeline/entity-pipeline entity)
        config-access? (f-permissions/field-option-create-access?
                        field
                        (:entity/type entity)
                        pipeline-id)
        can-create? (and create-on-fly?
                         (or system-level-creatable?
                             (and single-creatable?
                                  module-access?)
                             config-access?))]
    can-create?))

(defn cell-data-extractors
  [[_ ctx _cell-args]]
  [(rf/subscribe [::common-sub/loading? ctx])
   (rf/subscribe [::edit-mode? ctx])
   (rf/subscribe [::common-sub/entities ctx])
   (rf/subscribe [::entity-edits ctx])
   (rf/subscribe [::entity-edit-entities ctx])
   (rf/subscribe [::session-sub/entities])
   (rf/subscribe [::session-sub/tenant])
   (rf/subscribe [::session-sub/tenant-schema])
   (rf/subscribe [::session-sub/dealflow?])
   (rf/subscribe [::session-sub/fundraising?])
   (rf/subscribe [::session-sub/portfolio?])])


;; FIXME: Not pure function since uses f-permissions. Create new pure permission check fns for frontend
;; TODO: Cleanup and split into smaller parts
(defn cell-data-computation
  [[loading?
    _edit-mode?
    card-entities
    card-entity-edits
    edit-entities
    global-entities
    tenant
    tenant-schema
    dealflow?
    fundraising?
    portfolio?]
   [_
    {:keys [card entity-id] :as _ctx}
    {:keys [field editor? always-visible? empty-cell-value] :as _cell-args}]]
  (let [entity (get card-entities entity-id)
        entity-type (:card/entity-type card)

        ;; TODO: Make sure subscription returns changes in ref-entities
        all-entities-by-id (merge {}
                                  (when editor?
                                    edit-entities)
                                  card-entities
                                  global-entities)
        field-schema (registry/get-field-schema tenant-schema field)
        ;; FIXME: remove reference to f-permissions when new functions implemented
        read-access? (f-permissions/field-read-access? field
                                                       entity-type
                                                       (pipeline/pipeline entity))
        write-access? (f-permissions/field-write-access? field
                                                         entity-type
                                                         (pipeline/pipeline entity))

        field-label (loc/field-name field field-schema)

        data-type (if (year-fields-set field)
                    :data.type/date-year
                    (:field/data-type field-schema))
        options (resolve-field-options {:field-schema field-schema
                                        :entities     all-entities-by-id
                                        :tenant tenant})

        secondary-field (:field/secondary-attribute field-schema)

        primary-entity-edits (get card-entity-edits entity-id)
        base-data {:field            field
                   :field-label      field-label
                   :pipeline-id      (pipeline/containing-pipeline-id entity)
                   :options          options
                   :data-type        data-type
                   :loading?         loading?
                   :write-access?    write-access?
                   :hidden?          (not always-visible?)
                   :field-schema field-schema
                   :empty-cell-value empty-cell-value
                   :can-create-option-on-fly? (can-create-option-on-fly?
                                               {:field field
                                                :field-schema field-schema
                                                :entity entity
                                                :dealflow? dealflow?
                                                :fundraising? fundraising?
                                                :portfolio? portfolio?})}]
    (if loading?
      base-data
      (let [value (if (and editor? (contains? primary-entity-edits field))
                    (get primary-entity-edits field)
                    (get entity field))
            value (if (set? value)
                    (vec value)
                    value)
            materialized-value (uu/field-value->materialized-value
                                {:field         field
                                 :value         value
                                 :id->entity    all-entities-by-id
                                 :tenant        tenant
                                 :entity        entity
                                 :tenant-schema tenant-schema
                                 :show-currency? true})
            empty-value? (cu/empty-value? materialized-value)
            hidden? (or (not read-access?)
                        (and empty-value?
                             (not always-visible?)
                             (not editor?)))

            secondary-field-data (when secondary-field
                                   (let [field secondary-field
                                         field-schema (registry/get-field-schema tenant-schema field)
                                         write-access? (f-permissions/field-write-access? field
                                                                                          entity-type
                                                                                          (pipeline/pipeline entity))
                                         field-label (loc/field-name field field-schema)
                                         data-type (if (year-fields-set field)
                                                     :data.type/date-year
                                                     (:field/data-type field-schema))
                                         options (resolve-field-options {:field-schema field-schema
                                                                         :entities     all-entities-by-id})
                                         value (if (and editor? (contains? primary-entity-edits field))
                                                 (get primary-entity-edits field)
                                                 (get entity field))
                                         value (if (set? value)
                                                 (vec value)
                                                 value)
                                         value (if (= data-type :data.type/currency-symbol)
                                                 (or value (:tenant/default-currency tenant))
                                                 value)
                                         materialized-value (uu/field-value->materialized-value
                                                             {:field         field
                                                              :value         value
                                                              :id->entity    all-entities-by-id
                                                              :tenant        tenant
                                                              :entity        entity
                                                              :tenant-schema tenant-schema
                                                              :show-currency? true})
                                         empty-value? (cu/empty-value? materialized-value)]
                                     {:field field
                                      :field-label field-label
                                      :field-schema field-schema
                                      :value value
                                      :data-type data-type
                                      :materialized-value materialized-value
                                      :options options
                                      :empty-value? empty-value?
                                      :write-access? write-access?}))]
        (merge base-data
               {:value              value
                :materialized-value materialized-value
                :hidden?            hidden?}
               (when secondary-field
                 {:secondary-field-data secondary-field-data}))))))


;; Register subscriptions
(rf/reg-sub
 ::cell-data
 cell-data-extractors
 cell-data-computation)
